import * as FontAwesomeSix from 'react-icons/fa6';
import React from 'react';

export default function RichTextDescriptionItem({ id, iconName, title, text }) {
  return (
    <div className="flex px-1 pb-2" key={id}>
      <div className="text-xs mt-1 text-gray-500 mr-1">
        {React.createElement(FontAwesomeSix[`${iconName}`])}
      </div>
      <div className="pl-1">
        <span className="h-full font-bold text-xs rich-text-weak-content justify-start text-justify">
          {title}:{' '}
        </span>
        <span className="h-full text-xs rich-text-weak-content justify-start text-justify">
          {text}
        </span>
      </div>
    </div>
  );
}
